export default __webpack_public_path__ + "static/media/bg-top.cb61d7c2.png";